import { LoaderCircle } from "lucide-react";

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <LoaderCircle size={48} className="animate-spin text-black font-bold" />
    </div>
  );
};

export default Loader;
